export function durationToFormattedString(duration: number) {
  const hours = Math.floor(duration / 60)
  const minutes = Math.floor(duration % 60)
  return `${hours}h ${minutes}m`
}
